import { normalize, schema } from 'normalizr'
import { camelizeKeys } from 'humps'
import Auth from '../security/Auth'
import {applicationConfig} from '../config/config.js'


// Fetches an API response and normalizes the result JSON according to schema.
// This makes every API response have the same shape, regardless of how nested it was.
const callApi = (request, schema) => {

  return fetch(request).then(response =>
            response.json().then(json => {
              if (!response.ok) {
                return Promise.reject(json)
              }

              const camelizedJson = camelizeKeys(json)

              return Object.assign({},
                //normalize(camelizedJson, schema),
                camelizedJson
              )
            })
          )
}


// Action key that carries API call info interpreted by this Redux middleware.
export const CALL_API = 'Call API'


// A Redux middleware that interprets actions with CALL_API info specified.
// Performs the call and promises when such actions are dispatched.
export default store => next => action => {
  const callAPI = action[CALL_API]
  if (typeof callAPI === 'undefined') {
    return next(action)
  }

  let { endpoint,contentType } = callAPI
  const { schema, types, method } = callAPI
  let {body} = callAPI

  if (typeof endpoint === 'function') {
    endpoint = endpoint(store.getState())
  }

  if (typeof endpoint !== 'string') {
    throw new Error('Specify a string endpoint URL.')
  }
  if (!Array.isArray(types) || types.length !== 3) {
    throw new Error('Expected an array of three action types.')
  }
  if (!types.every(type => typeof type === 'string')) {
    throw new Error('Expected action types to be strings.')
  }
  if (!method) {
    throw new Error('Expected param method, must be one of -> get, post, put, patch, delete is not allowed')
  }
  if(!contentType) {
    contentType = 'application/json'
  }
  if ((method === 'post' || method ==='put' || method === 'patch') && !body)  {
      throw new Error('Expected body for method: ' + method)
  }
  if (body) {
    body = JSON.stringify(body)
  }

  const actionWith = data => {
    const finalAction = Object.assign({}, action, data)
    delete finalAction[CALL_API]
    return finalAction
  }

  const [ requestType, successType, failureType ] = types
  next(actionWith({ type: requestType }))


  const fullUrl = (endpoint.indexOf(applicationConfig.API_ROOT) === -1) ? applicationConfig.API_ROOT + endpoint : endpoint

  const headers = {
    'Accept': 'application/json',
    'Content-Type': contentType
  };

  const accessToken = new Auth().getAccessToken()

  if (accessToken != null && accessToken !== "")
    headers['Authorization'] = 'Bearer ' + accessToken;


  var request = new Request(fullUrl, {
  	method: method,
    credentials: 'include',

    headers: headers,
    body: body
  });

  return callApi(request, schema).then(
    response => next(actionWith({
      response,
      type: successType
    })),
    error => next(actionWith({
      type: failureType,
      error: error.message || 'Something bad happened'
    }))
  )
}



// WEBPACK FOOTER //
// ./src/middleware/api.js